export default "__VITE_ASSET__DSVDjLqL__"